<template lang="pug">
  div.optimal-layout__wrapper
    optimal-layout-location(
      :year-options="yearOptions"
      :parameters-list="parametersList"
      :map-center="mapCenter"
    )
    optimal-layout-params(
      :year-options="yearOptions"
      :parameters-list="parametersList"
      :map-center="mapCenter"
    )
</template>

<script>
  import OptimalLayoutLocation from "@/app/access/optimal-layout-components/optimal-layout-location";
  import OptimalLayoutParams from "@/app/access/optimal-layout-components/optimal-layout-params";
  import {threads} from "@/api/api-endpoints";
  import axios from "axios";
  import {MAP} from "@/config/map";

  export default {
    components: {OptimalLayoutParams, OptimalLayoutLocation},
    data() {
      return {
        parametersList: [],
        mapCenter: MAP,
      }
    },
    computed: {
      yearOptions() {
        const date = new Date();
        const years = [];
        const yearStart = date.getFullYear();
        const yearFinish = yearStart + 10;
        for (let i = yearStart; i < yearFinish; i++) {
          years.push({ id: i, name: i })
        }
        return years;
      },
    },
    mounted() {
      this.getMaxParameterList();
    },
    methods: {
      setParametersList(list) {
        this.parametersList = list
      },
      async getMaxParameterList() {
        const url = threads.maxParametersList()
        axios
          .get(url)
          .then(response => (this.setParametersList(response.data)))
          .catch(e => this.$e.errorBox('Ошибка загрузки параметров! Обновите страницу'))
      }
    }
  }
</script>

<style lang="scss">
.optimal-layout__wrapper {
  margin-top: 100px;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;

  .optimal-layout__col {
    flex-basis: calc(100% / 2 - 10px);
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 6px 0 #cfd1d6;
    margin-bottom: 20px;
  }

  .optimal-layout__col_title {
    margin: 0 0 10px;
    font-family: SFUIText-Semibold, sans-serif;
    font-size: 16px;
    font-weight: 600;
  }

  .form__elem_margin-bottom {
    margin-bottom: 10px;
  }

  .form__elem_label {
    margin: 10px 0 10px;
  }

  .form__elem_input {
    width: 100%;
  }

  .form-elem__btn {
    margin-top: 14px;
    border: 1px solid #d3dbe4;
    padding: 10px 18px;
    background: transparent;
    font-family: SFUIText-Semibold, sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #8c959f;
    height: 36px;
  }
}
</style>
